<div class="flex items-center justify-between bg-white z-10 top-4 right-4 left-4 mx-auto absolute">
    <h6 class="text-black text-base font-bold">اتاق های انتخابی({{ selectedComboRooms?.length ? selectedRoomsCount + 2 :
        selectedRoomsCount}})</h6>
    <!-- <button mat-button color="warn" class="!text-red-400 !font-bold" (click)="clearAll()">حذف همه</button> -->
    <button mat-button color="warn" class="!text-red-400 !font-bold cursor-pointer" (click)="clearAll()"
        *ngIf="!selectedComboRooms?.length">حذف همه</button>
</div>

<!-- should iterate over each room --- selectedRooms count --->
<div class="overflow-y-auto pb-[11rem] selected-rooms-scrollable">

    <ng-container *ngIf="selectedComboRooms?.length">
        <div class="w-full py-4 border-bottom">
            <div class="flex items-center justify-between w-full">
                <p class="text-sm font-bold text-black">اتاق ترکیبی</p>
                <i class="ico-Close text-xl font-bold text-gray-300 !cursor-pointer hover:!text-gray-400"
                    (click)="emitRemoveComboRooms()"></i>
                <!-- <i class="ico-Close text-xl text-muted"></i> -->
            </div>

            <div class="flex flex-col gap-2 py-2">
                <p class="text-black text-sm font-semi-bold" *ngFor="let eachCombo of selectedComboRooms?.[0]?.rooms">
                    {{ eachCombo.roomName }}
                </p>
            </div>

            <div class="flex w-full items-center gap-1 mt-2 justify-end">
                <span class="text-sm text-muted">{{ selectedComboRooms![0]?.totalPrice?.nights }} شب</span>
                <span class="text-black-500 text-2xl font-bold">{{
                    selectedComboRooms![0].totalPrice?.ihoPrice | toToman | number : '2.'
                    }}</span>
                <span class="text-sm text-muted">تومان</span>
            </div>
        </div>
    </ng-container>

    <div class="w-full py-4 border-bottom" *ngFor="let eachRoom of dataSource">
        <div class="flex items-center justify-between w-full">
            <p class="text-sm font-bold text-black">{{ eachRoom.name }}</p>
            <i class="ico-Close text-xl font-bold text-gray-300 !cursor-pointer hover:!text-gray-400"
                (click)="resetCountForSpecificRoom(eachRoom.id)"></i>
            <!-- <i class="ico-Close text-xl text-muted"></i> -->
        </div>

        <span>{{ eachRoom.count }} اتاق</span>

        <div class="flex w-full items-center gap-1 justify-end">
            <!-- <span class="text-sm text-muted">{{ ds?.Price?.StartingText }}</span> -->
            <span class="text-sm text-muted">{{ eachRoom.roomPrice.price.nights }} شب</span>
            <!-- <span class="text-black text-xl font-bold">{{ ds?.Price?.IhoPrice | toToman | number: '2.' }}</span> -->
            <span class="text-black text-xl font-bold">{{ eachRoom.roomPrice.price.ihoPrice | toToman | number: '2.'
                }}</span>
            <span class="text-sm text-muted">تومان</span>
        </div>
    </div>
</div>

<div class="flex flex-col w-full items-center justify-end absolute bottom-0 left-0 righFt-0 mx-auto p-4 !pt-0 bg-white">
    <div class="w-full flex items-center justify-end gap-1 py-4">

        <span class="text-sm text-muted">مبلغ قابل پرداخت</span>
      
        <span class="text-black text-left text-xl font-bold">{{ (totalPrice + totalComboPrice) | toToman | number: '2.'
            }}</span>
        <span class="text-sm text-muted">تومان</span>
    </div>
   
    <div class="w-full">
        <button id="make-reservation-btn" [disabled]="disabledBtn" mat-flat-button color="primary" class="w-full !h-11"
            (click)="goToFollowReservation()">
            اقدام به رزرو
        </button>
    </div>
</div>